import React,{Component} from 'react';

import styles from './index.module.css';

class Footer extends Component{
  render(){
    return(
      <div className={styles.footer}>
        E-mail: info@qsmttech.com 电话: 010-88579825/26/27/28/29
        <br /> 版权所有: 北京青色麦田科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;<a href="http://www.miitbeian.gov.cn/">京ICP备16039554号-1</a>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js